import React, { useEffect, useState, useRef, useMemo } from 'react';
import { supabase } from '../supabase';
import { useNavigate } from 'react-router-dom';

const ADMIN_EMAIL = 'colebartimus@getreplyfirst.com';
const BACKEND_URL = 'https://replyfirst-production.up.railway.app';
const FROM_NUMBER = '(740) 880-8424';
const FONT = "'Plus Jakarta Sans', system-ui, sans-serif";

const INDUSTRIES = [
  'auto repair',
  'plumbing',
  'garage door repair',
  'HVAC',
  'electrical',
  'roofing',
  'landscaping',
  'pest control',
  'cleaning',
  'general contractor',
  'towing',
  'locksmith',
  'pressure washing',
  'handyman',
];

// Template A: Yelp compliment + short pain question + industry curiosity closer
const INDUSTRY_MESSAGES_A = {
  'auto repair':        (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how auto repair shops are handling it.\n\n-Cole`,
  'plumbing':           (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how plumbers are handling it.\n\n-Cole`,
  'garage door repair': (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how garage door companies are handling it.\n\n-Cole`,
  'HVAC':               (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how HVAC companies are handling it.\n\n-Cole`,
  'electrical':         (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how electricians are handling it.\n\n-Cole`,
  'roofing':            (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how roofing companies are handling it.\n\n-Cole`,
  'landscaping':        (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how landscaping companies are handling it.\n\n-Cole`,
  'pest control':       (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how pest control companies are handling it.\n\n-Cole`,
  'cleaning':           (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how cleaning companies are handling it.\n\n-Cole`,
  'general contractor': (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how contractors are handling it.\n\n-Cole`,
  'towing':             (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how towing companies are handling it.\n\n-Cole`,
  'locksmith':          (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how locksmiths are handling it.\n\n-Cole`,
  'pressure washing':   (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how pressure washing companies are handling it.\n\n-Cole`,
  'handyman':           (businessName) => `Hey, saw ${businessName} on Yelp, it looks like you do great work. Quick question for you, do you ever lose jobs because you missed a call while you are busy? Just curious how handymen are handling it.\n\n-Cole`,
};

// Template B: Yelp reference + trade-specific activity + pain closer
const INDUSTRY_MESSAGES_B = {
  'auto repair':        (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are under a car or with a customer? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'plumbing':           (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are on a job or dealing with a leak? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'garage door repair': (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are out on a service call? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'HVAC':               (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are up in an attic or out on a job? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'electrical':         (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are in the middle of a job? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'roofing':            (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are up on a roof? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'landscaping':        (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are out mowing or on a property? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'pest control':       (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are treating a property? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'cleaning':           (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are in the middle of a clean? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'general contractor': (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are on a job site? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'towing':             (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are already out on a call? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'locksmith':          (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are already with someone? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'pressure washing':   (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are mid-job with equipment running? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
  'handyman':           (businessName) => `Hey, came across ${businessName} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are in the middle of a job? Curious how you are keeping that business from going to the next company.\n\n-Cole`,
};

const buildMessage = (businessName, industry, template) => {
  const map = template === 'A' ? INDUSTRY_MESSAGES_A : INDUSTRY_MESSAGES_B;
  const fn = map[industry];
  if (fn) return fn(businessName || 'your business');
  if (template === 'A') return `Hey, do you ever lose jobs because you missed a call while you are busy? Just curious.\n\n-Cole`;
  return `Hey, came across ${businessName || 'your business'} on Yelp. If you don't mind I had a quick question, do you ever miss calls when you are out on a job? Curious how you are keeping that business from going to the next company.\n\n-Cole`;
};

// ───────────────────────── Compliance helpers ─────────────────────────

// States with stricter texting laws than federal (Texas SB 140, Florida FTSA, Oklahoma OTSA).
const STRICT_STATE_AREA_CODES = {
  TX: ['210','214','254','281','325','346','361','409','430','432','469','512','682','713','726','737','806','817','830','832','903','915','936','940','945','956','972','979'],
  FL: ['239','305','321','324','352','386','407','448','561','645','656','689','727','728','754','772','786','813','850','863','904','941','954'],
  OK: ['405','539','572','580','918'],
};
const AREA_CODE_TO_STRICT_STATE = Object.fromEntries(
  Object.entries(STRICT_STATE_AREA_CODES).flatMap(([state, codes]) => codes.map(c => [c, state]))
);

// Area codes west of Central time. Anything not listed is treated as Eastern OR Central,
// and must be inside the window in both, so split states (IN, KY, TN, FL panhandle) are covered.
const AREA_CODE_ZONES = {};
const addZones = (codes, zones) => codes.forEach(c => { AREA_CODE_ZONES[c] = zones; });
addZones(['209','213','279','310','323','341','350','369','408','415','424','442','510','530','559','562','619','626','628','650','657','661','669','707','714','747','760','805','818','820','831','840','858','909','916','925','949','951', // CA
          '206','253','360','425','509','564', // WA
          '458','503','541','971',             // OR
          '702','725','775'],                  // NV
         ['America/Los_Angeles']);
addZones(['303','719','720','970','983', '385','435','801', '505','575', '406', '307', '915'], ['America/Denver']);
addZones(['480','520','602','623','928'], ['America/Phoenix']);
addZones(['208','986'], ['America/Denver', 'America/Los_Angeles']); // Idaho is split
addZones(['907'], ['America/Anchorage']);
addZones(['808'], ['Pacific/Honolulu']);
const DEFAULT_ZONES = ['America/New_York', 'America/Chicago'];

// Federal quiet hours are 8am–9pm local. We use a stricter 9am–8pm.
const SEND_START_HOUR = 9;
const SEND_END_HOUR = 20;

const normalizePhone = (raw) => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
  return digits;
};
const isValidPhone = (digits) => /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
const formatPhone = (digits) => digits.length === 10 ? `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}` : digits;

const zonesFor = (digits) => AREA_CODE_ZONES[digits.slice(0, 3)] || DEFAULT_ZONES;
const localHour = (zone, now) =>
  Number(new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: zone }).format(now)) % 24;
const insideSendingWindow = (digits, now) =>
  zonesFor(digits).every(z => { const h = localHour(z, now); return h >= SEND_START_HOUR && h < SEND_END_HOUR; });
const localTimeLabel = (digits, now) => {
  const zones = zonesFor(digits);
  const fmt = (z) => new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', timeZone: z, timeZoneName: 'short' }).format(now);
  return zones.map(fmt).join(' / ');
};

// Opt-out detection. Carrier keywords must be the whole message; phrases can appear anywhere.
const OPT_OUT_KEYWORDS = ['stop', 'stopall', 'stop all', 'unsubscribe', 'cancel', 'end', 'quit', 'opt out', 'optout', 'revoke'];
const OPT_OUT_PHRASES = /(not interested|no thanks|no thank you|remove me|take me off|don'?t (text|contact|message)|do not (text|contact|message)|stop (texting|messaging|contacting)|wrong number|lose (this|my) number|leave me alone|unsubscribe)/i;
const isOptOutMessage = (body) => {
  const text = String(body || '').trim().toLowerCase().replace(/[.!?\s]+$/, '');
  return OPT_OUT_KEYWORDS.includes(text) || OPT_OUT_PHRASES.test(text);
};
const inboundOptOut = (contact) => {
  const conv = Array.isArray(contact?.conversation) ? contact.conversation : [];
  return conv.some(m => m.direction === 'inbound' && isOptOutMessage(m.body));
};
const hasOptedOut = (contact) => !!contact && (contact.status === 'not_interested' || inboundOptOut(contact));

// "Business name, phone" per line. Splits on the LAST comma so names with commas still work.
const parseList = (text) => {
  const seen = new Set();
  const out = [];
  text.split('\n').forEach((line, i) => {
    if (!line.trim()) return;
    const idx = line.lastIndexOf(',');
    if (idx === -1) return;
    const business_name = line.slice(0, idx).trim().replace(/^"|"$/g, '');
    const phone = normalizePhone(line.slice(idx + 1));
    const key = phone || `row-${i}`;
    if (seen.has(key)) return;
    seen.add(key);
    out.push({ key, business_name, phone });
  });
  return out;
};

const smsSegments = (len) => (len === 0 ? 0 : len <= 160 ? 1 : Math.ceil(len / 153));

// ───────────────────────── Component ─────────────────────────

function Outreach() {
  const navigate = useNavigate();
  const [authorized, setAuthorized] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [replyText, setReplyText] = useState('');
  const [sendingReply, setSendingReply] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [activeTab, setActiveTab] = useState('contacts');
  const [csvText, setCsvText] = useState('');
  const [queue, setQueue] = useState([]);
  const [currentKey, setCurrentKey] = useState(null);
  const [drafts, setDrafts] = useState({});
  const [selectedIndustry, setSelectedIndustry] = useState('auto repair');
  const [filterStatus, setFilterStatus] = useState('all');
  const [now, setNow] = useState(new Date());
  const [copiedKey, setCopiedKey] = useState(null);
  const selectedContactRef = useRef(null);

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || user.email !== ADMIN_EMAIL) {
        navigate('/', { replace: true });
        return;
      }
      setAuthorized(true);
      fetchContacts();
    };
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  // Auto-refresh every 30 seconds to pick up new replies
  useEffect(() => {
    if (!authorized) return;
    const interval = setInterval(() => { fetchContactsSilent(); }, 30000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorized]);

  // Clock tick so the sending-window checks stay current
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    selectedContactRef.current = selectedContact;
  }, [selectedContact]);

  // Anyone whose reply reads as an opt-out gets marked not_interested automatically.
  const applyOptOutSync = async (rows) => {
    const flagged = rows.filter(c => c.status !== 'not_interested' && inboundOptOut(c));
    if (!flagged.length) return rows;
    await Promise.all(flagged.map(c =>
      supabase.from('outreach_contacts').update({ status: 'not_interested' }).eq('id', c.id)
    ));
    const ids = new Set(flagged.map(c => c.id));
    return rows.map(c => (ids.has(c.id) ? { ...c, status: 'not_interested' } : c));
  };

  const fetchContacts = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('outreach_contacts')
      .select('*')
      .order('created_at', { ascending: false });
    setContacts(await applyOptOutSync(data || []));
    setLoading(false);
  };

  // Silent refresh — no loading spinner, also refreshes open conversation panel
  const fetchContactsSilent = async () => {
    const { data } = await supabase
      .from('outreach_contacts')
      .select('*')
      .order('created_at', { ascending: false });
    if (data) {
      const rows = await applyOptOutSync(data);
      setContacts(rows);
      const current = selectedContactRef.current;
      if (current) {
        const fresh = rows.find(c => c.id === current.id);
        if (fresh) setSelectedContact(fresh);
      }
    }
  };

  // Every number ever contacted, keyed by normalized digits — this is the suppression list.
  const contactedByPhone = useMemo(() => {
    const m = new Map();
    contacts.forEach(c => m.set(normalizePhone(c.phone_number), c));
    return m;
  }, [contacts]);

  const sentToday = useMemo(() => {
    const today = now.toDateString();
    return contacts.filter(c => c.sent_at && new Date(c.sent_at).toDateString() === today).length;
  }, [contacts, now]);

  const checkItem = (item) => {
    const blocks = [];
    const warnings = [];
    if (!isValidPhone(item.phone)) {
      blocks.push('Not a valid 10-digit US number');
      return { blocks, warnings };
    }
    const existing = contactedByPhone.get(item.phone);
    if (existing && !item.sent) {
      blocks.push(hasOptedOut(existing) ? 'Opted out / not interested. Never text again.' : 'Already contacted');
    }
    const state = AREA_CODE_TO_STRICT_STATE[item.phone.slice(0, 3)];
    if (state) warnings.push(`${state} number. ${state} has a stricter state texting law.`);
    if (!insideSendingWindow(item.phone, now)) {
      blocks.push(`Outside ${SEND_START_HOUR}am–${SEND_END_HOUR - 12}pm in their time zone`);
    }
    return { blocks, warnings };
  };

  const currentItem = queue.find(q => q.key === currentKey) || null;
  const currentDraft = currentItem ? (drafts[currentItem.key] ?? '') : '';
  const setCurrentDraft = (text) => {
    if (!currentItem) return;
    setDrafts(d => ({ ...d, [currentItem.key]: text }));
  };

  const handleListChange = (e) => {
    const text = e.target.value;
    setCsvText(text);
    const parsed = parseList(text);
    setQueue(prev => {
      const sentKeys = new Set(prev.filter(p => p.sent).map(p => p.key));
      return parsed.map(p => ({ ...p, sent: sentKeys.has(p.key) }));
    });
    if (!parsed.some(p => p.key === currentKey)) setCurrentKey(parsed[0]?.key || null);
  };

  const copyText = async (key, text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(null), 1500);
    } catch {
      setCurrentDraft(text); // clipboard blocked: drop it into the message box instead
    }
  };

  const handleSendOne = async () => {
    if (!currentItem || currentItem.sent) return;
    const message = currentDraft.trim();
    if (!message) return;
    const { blocks, warnings } = checkItem(currentItem);
    if (blocks.length) return;
    if (warnings.length && !window.confirm(`${warnings.join('\n')}\n\nSend anyway?`)) return;

    setSending(true);
    try {
      const res = await fetch(`${BACKEND_URL}/outreach/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          contacts: [{ business_name: currentItem.business_name, phone_number: currentItem.phone, message }],
          industry: selectedIndustry,
          template: 'custom',
          message,
        }),
      });
      const data = await res.json();
      if (data.success && data.sent > 0) {
        const sentKey = currentItem.key;
        const updated = queue.map(q => (q.key === sentKey ? { ...q, sent: true } : q));
        setQueue(updated);
        const idx = updated.findIndex(q => q.key === sentKey);
        const next = [...updated.slice(idx + 1), ...updated.slice(0, idx)].find(q => !q.sent);
        setCurrentKey(next ? next.key : sentKey);
        await fetchContacts();
      } else if (data.success) {
        alert('Not sent. The server skipped it (already contacted or invalid number).');
      } else {
        alert(`Error: ${data.error}`);
      }
    } catch (err) {
      alert('Failed to send. Check Railway logs.');
    }
    setSending(false);
  };

  const handleReply = async () => {
    if (!replyText.trim() || !selectedContact || hasOptedOut(selectedContact)) return;
    setSendingReply(true);
    try {
      const res = await fetch(`${BACKEND_URL}/outreach/respond`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contactId: selectedContact.id, message: replyText.trim() }),
      });
      const data = await res.json();
      if (data.success) {
        setReplyText('');
        await fetchContacts();
        const fresh = await supabase.from('outreach_contacts').select('*').eq('id', selectedContact.id).single();
        if (fresh.data) setSelectedContact(fresh.data);
      } else if (data.error) {
        alert(`Error: ${data.error}`);
      }
    } catch (err) {
      alert('Failed to send reply.');
    }
    setSendingReply(false);
  };

  const handleStatusUpdate = async (contactId, status) => {
    await supabase.from('outreach_contacts').update({ status }).eq('id', contactId);
    await fetchContacts();
    if (selectedContact && selectedContact.id === contactId) {
      setSelectedContact(prev => ({ ...prev, status }));
    }
  };

  const handleSaveNote = async () => {
    if (!selectedContact) return;
    await supabase.from('outreach_contacts').update({ notes: noteText }).eq('id', selectedContact.id);
    await fetchContacts();
    setSelectedContact(prev => ({ ...prev, notes: noteText }));
  };

  const formatDate = (iso) => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  };

  const statusColor = (status) => {
    if (status === 'replied') return { bg: '#ECFDF3', color: '#166534', border: '#BBF7D0' };
    if (status === 'sent') return { bg: '#EEF3FF', color: '#1A56DB', border: '#C3D2F7' };
    if (status === 'not_interested') return { bg: '#F4F7FF', color: '#9AABBE', border: '#DDE3F0' };
    if (status === 'converted') return { bg: '#FFF7ED', color: '#92400E', border: '#FED7AA' };
    return { bg: '#F4F7FF', color: '#9AABBE', border: '#DDE3F0' };
  };

  const filteredContacts = filterStatus === 'all' ? contacts : contacts.filter(c => c.status === filterStatus);
  const counts = {
    all: contacts.length,
    sent: contacts.filter(c => c.status === 'sent').length,
    replied: contacts.filter(c => c.status === 'replied').length,
    not_interested: contacts.filter(c => c.status === 'not_interested').length,
    converted: contacts.filter(c => c.status === 'converted').length,
  };

  if (!authorized) return null;

  const card = { backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #DDE3F0', padding: '24px', boxShadow: '0 2px 8px rgba(26,86,219,0.06)' };
  const h2 = { margin: '0 0 16px', fontFamily: "'Fraunces', serif", fontSize: '18px', fontWeight: 700, color: '#0C1A2E' };
  const label = { display: 'block', fontSize: '13px', fontWeight: 600, color: '#0C1A2E', marginBottom: '6px' };
  const chip = (bg, color, border) => ({ padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: 700, backgroundColor: bg, color, border: `1px solid ${border}`, whiteSpace: 'nowrap' });
  const smallBtn = { padding: '5px 12px', borderRadius: '8px', border: '1px solid #DDE3F0', backgroundColor: '#fff', color: '#1A56DB', fontSize: '12px', fontWeight: 700, cursor: 'pointer', fontFamily: FONT };

  const currentChecks = currentItem ? checkItem(currentItem) : { blocks: [], warnings: [] };
  const canSend = !!currentItem && !currentItem.sent && !sending && currentDraft.trim().length > 0 && currentChecks.blocks.length === 0;
  const readyCount = queue.filter(q => !q.sent && checkItem(q).blocks.length === 0).length;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F4F7FF', padding: '32px', boxSizing: 'border-box', fontFamily: FONT }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

        <header style={{ marginBottom: '24px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <h1 style={{ margin: 0, fontFamily: "'Fraunces', serif", fontSize: '28px', fontWeight: 800, color: '#0C1A2E', letterSpacing: '-0.5px' }}>Outreach</h1>
              <span style={{ padding: '3px 10px', borderRadius: '999px', backgroundColor: '#F97316', color: '#fff', fontSize: '11px', fontWeight: 700 }}>ADMIN</span>
            </div>
            <p style={{ margin: 0, fontSize: '14px', color: '#5A6B84' }}>Write each text yourself, send one at a time, manage replies. Replies notify your cell instantly.</p>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => { setActiveTab('contacts'); fetchContacts(); }} style={{ padding: '8px 16px', borderRadius: '999px', border: '1px solid', borderColor: activeTab === 'contacts' ? '#1A56DB' : '#DDE3F0', backgroundColor: activeTab === 'contacts' ? '#EEF3FF' : '#fff', color: activeTab === 'contacts' ? '#1A56DB' : '#5A6B84', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: FONT }}>
              Contacts ({contacts.length})
            </button>
            <button onClick={() => setActiveTab('add')} style={{ padding: '8px 16px', borderRadius: '999px', border: 'none', backgroundColor: '#F97316', color: '#fff', fontSize: '13px', fontWeight: 700, cursor: 'pointer', fontFamily: FONT }}>
              + New Outreach
            </button>
          </div>
        </header>

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px', marginBottom: '20px' }}>
          {[
            { label: 'Total', value: counts.all, color: '#0C1A2E' },
            { label: 'Sent', value: counts.sent, color: '#1A56DB' },
            { label: 'Replied', value: counts.replied, color: '#166534' },
            { label: 'Not Interested', value: counts.not_interested, color: '#9AABBE' },
            { label: 'Converted', value: counts.converted, color: '#F97316' },
          ].map(stat => (
            <div key={stat.label} style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '14px 16px', border: '1px solid #DDE3F0', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', fontFamily: "'Fraunces', serif", fontWeight: 800, color: stat.color }}>{stat.value}</div>
              <div style={{ fontSize: '11px', color: '#9AABBE', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: '2px' }}>{stat.label}</div>
            </div>
          ))}
        </div>

        {activeTab === 'add' ? (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', alignItems: 'start' }}>

            {/* ── Left: list + queue ── */}
            <div style={card}>
              <h2 style={h2}>Today's List</h2>

              <div style={{ marginBottom: '16px' }}>
                <label style={label}>Industry (for templates)</label>
                <select value={selectedIndustry} onChange={e => setSelectedIndustry(e.target.value)}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #DDE3F0', fontSize: '14px', fontFamily: FONT, outline: 'none', color: '#0C1A2E' }}>
                  {INDUSTRIES.map(i => <option key={i} value={i}>{i.charAt(0).toUpperCase() + i.slice(1)}</option>)}
                </select>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <label style={{ ...label, marginBottom: '4px' }}>Paste your list</label>
                <div style={{ fontSize: '12px', color: '#9AABBE', marginBottom: '6px' }}>One per line: <code>Mike's Auto Shop, 7405551234</code></div>
                <textarea value={csvText} onChange={handleListChange}
                  placeholder={"Mike's Auto Shop, 7405551234\nJohn's Plumbing, 6145559012\nABC HVAC, 9803756789"}
                  rows={5}
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #DDE3F0', fontSize: '13px', fontFamily: 'monospace', outline: 'none', boxSizing: 'border-box', resize: 'vertical', color: '#0C1A2E' }} />
              </div>

              {queue.length > 0 && (
                <>
                  <div style={{ fontSize: '12px', color: '#5A6B84', marginBottom: '8px', fontWeight: 600 }}>
                    {readyCount} ready · {queue.filter(q => q.sent).length} sent · {queue.length} total
                  </div>
                  <div style={{ border: '1px solid #DDE3F0', borderRadius: '10px', overflow: 'hidden' }}>
                    {queue.map((item, i) => {
                      const { blocks, warnings } = checkItem(item);
                      const isCurrent = item.key === currentKey;
                      let status;
                      if (item.sent) status = <span style={chip('#ECFDF3', '#166534', '#BBF7D0')}>✓ Sent</span>;
                      else if (blocks.length) status = <span style={chip('#FEF2F2', '#991B1B', '#FECACA')}>Blocked</span>;
                      else if (warnings.length) status = <span style={chip('#FFFBEB', '#92400E', '#FDE68A')}>Check</span>;
                      else status = <span style={chip('#EEF3FF', '#1A56DB', '#C3D2F7')}>Ready</span>;
                      return (
                        <div key={item.key} onClick={() => setCurrentKey(item.key)}
                          style={{ padding: '10px 14px', borderBottom: i < queue.length - 1 ? '1px solid #EEF2FF' : 'none', cursor: 'pointer', backgroundColor: isCurrent ? '#EEF3FF' : '#fff', opacity: item.sent ? 0.6 : 1 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                            <div style={{ fontWeight: 700, color: '#0C1A2E', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.business_name || '(no name)'}</div>
                            {status}
                          </div>
                          <div style={{ fontSize: '12px', color: '#9AABBE', marginTop: '2px' }}>
                            {formatPhone(item.phone)}{!item.sent && blocks.length > 0 ? ` · ${blocks[0]}` : ''}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>

            {/* ── Right: compose ── */}
            <div style={card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <h2 style={h2}>Compose</h2>
                <span style={{ fontSize: '12px', color: '#5A6B84', fontWeight: 600 }}>Sent today: {sentToday}</span>
              </div>

              {!currentItem ? (
                <div style={{ padding: '32px 12px', textAlign: 'center', color: '#5A6B84', fontSize: '14px' }}>
                  Paste a list on the left, then pick a contact to write their text.
                </div>
              ) : (
                <>
                  <div style={{ padding: '12px 14px', backgroundColor: '#F4F7FF', borderRadius: '10px', marginBottom: '12px' }}>
                    <div style={{ fontWeight: 700, color: '#0C1A2E', fontSize: '15px' }}>{currentItem.business_name || '(no name)'}</div>
                    <div style={{ fontSize: '12px', color: '#5A6B84', marginTop: '2px' }}>
                      {formatPhone(currentItem.phone)}
                      {isValidPhone(currentItem.phone) && <> · Their time: {localTimeLabel(currentItem.phone, now)}</>}
                    </div>
                    <div style={{ fontSize: '11px', color: '#9AABBE', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>Going out from {FROM_NUMBER}</div>
                  </div>

                  {currentItem.sent && (
                    <div style={{ padding: '10px 14px', backgroundColor: '#ECFDF3', border: '1px solid #BBF7D0', borderRadius: '8px', marginBottom: '12px', fontSize: '13px', color: '#166534', fontWeight: 600 }}>
                      ✓ Sent. Replies will show up in the Contacts tab.
                    </div>
                  )}
                  {!currentItem.sent && currentChecks.blocks.length > 0 && (
                    <div style={{ padding: '10px 14px', backgroundColor: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '8px', marginBottom: '12px', fontSize: '13px', color: '#991B1B' }}>
                      {currentChecks.blocks.map(b => <div key={b}>✕ {b}</div>)}
                    </div>
                  )}
                  {!currentItem.sent && currentChecks.warnings.length > 0 && (
                    <div style={{ padding: '10px 14px', backgroundColor: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: '8px', marginBottom: '12px', fontSize: '13px', color: '#92400E' }}>
                      {currentChecks.warnings.map(w => <div key={w}>⚠ {w}</div>)}
                    </div>
                  )}

                  <label style={label}>Your message</label>
                  <textarea value={currentDraft} onChange={e => setCurrentDraft(e.target.value)}
                    disabled={currentItem.sent}
                    placeholder="Write your text, or copy a template below and tweak it…"
                    rows={7}
                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #DDE3F0', fontSize: '14px', fontFamily: FONT, lineHeight: 1.6, outline: 'none', boxSizing: 'border-box', resize: 'vertical', color: '#0C1A2E' }} />
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#9AABBE', margin: '4px 0 12px' }}>
                    <span>{currentDraft.length} characters · {smsSegments(currentDraft.length)} SMS segment{smsSegments(currentDraft.length) === 1 ? '' : 's'}</span>
                  </div>

                  <button onClick={handleSendOne} disabled={!canSend}
                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: 'none', backgroundColor: canSend ? '#F97316' : '#DDE3F0', color: canSend ? '#fff' : '#9AABBE', fontSize: '14px', fontWeight: 700, cursor: canSend ? 'pointer' : 'not-allowed', fontFamily: FONT, marginBottom: '20px' }}>
                    {sending ? 'Sending…' : currentItem.sent ? 'Sent' : `Send to ${currentItem.business_name || formatPhone(currentItem.phone)} →`}
                  </button>

                  <div style={{ fontSize: '13px', fontWeight: 700, color: '#0C1A2E', marginBottom: '8px' }}>Templates</div>
                  {['A', 'B'].map(t => {
                    const text = buildMessage(currentItem.business_name, selectedIndustry, t);
                    const key = `${currentItem.key}-${t}`;
                    return (
                      <div key={t} style={{ border: '1px solid #DDE3F0', borderRadius: '10px', padding: '12px', marginBottom: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                          <span style={{ fontSize: '12px', fontWeight: 700, color: '#1A56DB' }}>Template {t}</span>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => copyText(key, text)} style={smallBtn}>{copiedKey === key ? '✓ Copied' : 'Copy'}</button>
                            <button onClick={() => setCurrentDraft(text)} disabled={currentItem.sent} style={smallBtn}>Use</button>
                          </div>
                        </div>
                        <div style={{ fontSize: '13px', color: '#5A6B84', lineHeight: 1.6, whiteSpace: 'pre-line' }}>{text}</div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>

        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: selectedContact ? '1fr 1fr' : '1fr', gap: '20px' }}>

            {/* Contact list */}
            <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #DDE3F0', boxShadow: '0 2px 8px rgba(26,86,219,0.06)', overflow: 'hidden' }}>
              <div style={{ padding: '14px 20px', borderBottom: '1px solid #DDE3F0' }}>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {[
                    { value: 'all', label: 'All' },
                    { value: 'replied', label: '💬 Replied' },
                    { value: 'sent', label: 'Sent' },
                    { value: 'converted', label: '🎉 Converted' },
                    { value: 'not_interested', label: 'Not Interested' },
                  ].map(f => (
                    <button key={f.value} onClick={() => setFilterStatus(f.value)}
                      style={{ padding: '5px 12px', borderRadius: '999px', border: '1px solid', borderColor: filterStatus === f.value ? '#1A56DB' : '#DDE3F0', backgroundColor: filterStatus === f.value ? '#EEF3FF' : '#fff', color: filterStatus === f.value ? '#1A56DB' : '#5A6B84', fontSize: '12px', fontWeight: 600, cursor: 'pointer', fontFamily: FONT }}>
                      {f.label} ({counts[f.value] ?? contacts.length})
                    </button>
                  ))}
                </div>
              </div>

              {loading ? (
                <div style={{ padding: '24px', color: '#9AABBE', fontSize: '14px' }}>Loading…</div>
              ) : filteredContacts.length === 0 ? (
                <div style={{ padding: '32px 24px', textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', marginBottom: '12px' }}>📤</div>
                  <div style={{ fontWeight: 600, color: '#0C1A2E', marginBottom: '6px' }}>No contacts yet</div>
                  <div style={{ fontSize: '13px', color: '#5A6B84' }}>Start a new outreach to reach out.</div>
                </div>
              ) : (
                filteredContacts.map((contact, i) => {
                  const sc = statusColor(contact.status);
                  const isSelected = selectedContact && selectedContact.id === contact.id;
                  const conversation = Array.isArray(contact.conversation) ? contact.conversation : [];
                  const hasUnread = contact.status === 'replied' && conversation.length > 0 && conversation[conversation.length - 1].direction === 'inbound';
                  return (
                    <div key={contact.id} onClick={() => { setSelectedContact(contact); setNoteText(contact.notes || ''); }}
                      style={{ padding: '14px 20px', borderBottom: i < filteredContacts.length - 1 ? '1px solid #EEF2FF' : 'none', cursor: 'pointer', backgroundColor: isSelected ? '#EEF3FF' : hasUnread ? '#F8FAFF' : '#fff' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          {hasUnread && <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#1A56DB', flexShrink: 0 }} />}
                          <div style={{ fontWeight: 700, color: '#0C1A2E', fontSize: '14px' }}>{contact.business_name || contact.phone_number}</div>
                        </div>
                        <span style={{ padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: 700, backgroundColor: sc.bg, color: sc.color, border: `1px solid ${sc.border}`, textTransform: 'capitalize' }}>
                          {(contact.status || 'pending').replace('_', ' ')}
                        </span>
                      </div>
                      <div style={{ fontSize: '12px', color: '#9AABBE' }}>{contact.phone_number} · {formatDate(contact.sent_at || contact.created_at)}</div>
                      {conversation.length > 0 && (
                        <div style={{ fontSize: '12px', color: '#5A6B84', marginTop: '4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {conversation[conversation.length - 1].direction === 'inbound' ? '← ' : '→ '}
                          {conversation[conversation.length - 1].body}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>

            {/* Conversation panel */}
            {selectedContact && (
              <div style={{ backgroundColor: '#fff', borderRadius: '14px', border: '1px solid #DDE3F0', boxShadow: '0 2px 8px rgba(26,86,219,0.06)', display: 'flex', flexDirection: 'column', maxHeight: '700px' }}>
                <div style={{ padding: '16px 20px', borderBottom: '1px solid #DDE3F0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <div>
                      <div style={{ fontWeight: 700, color: '#0C1A2E', fontSize: '16px' }}>{selectedContact.business_name}</div>
                      <div style={{ fontSize: '13px', color: '#9AABBE' }}>{selectedContact.phone_number}</div>
                    </div>
                    <button onClick={() => setSelectedContact(null)} style={{ width: '28px', height: '28px', borderRadius: '50%', border: '1px solid #DDE3F0', backgroundColor: '#F4F7FF', color: '#5A6B84', fontSize: '16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
                  </div>
                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                    {['sent', 'replied', 'not_interested', 'converted'].map(s => {
                      const sc = statusColor(s);
                      return (
                        <button key={s} onClick={() => handleStatusUpdate(selectedContact.id, s)}
                          style={{ padding: '4px 10px', borderRadius: '999px', border: '1px solid', borderColor: selectedContact.status === s ? sc.border : '#DDE3F0', backgroundColor: selectedContact.status === s ? sc.bg : '#fff', color: selectedContact.status === s ? sc.color : '#9AABBE', fontSize: '11px', fontWeight: 700, cursor: 'pointer', fontFamily: FONT, textTransform: 'capitalize' }}>
                          {selectedContact.status === s ? '✓ ' : ''}{s.replace('_', ' ')}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Messages */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {selectedContact.message_sent && (
                    <div style={{ alignSelf: 'flex-end', maxWidth: '80%' }}>
                      <div style={{ padding: '10px 14px', backgroundColor: '#1A56DB', color: '#fff', borderRadius: '12px 12px 2px 12px', fontSize: '13px', lineHeight: 1.6, whiteSpace: 'pre-line' }}>
                        {selectedContact.message_sent}
                      </div>
                      <div style={{ fontSize: '11px', color: '#9AABBE', textAlign: 'right', marginTop: '4px' }}>{formatDate(selectedContact.sent_at)}</div>
                    </div>
                  )}
                  {(Array.isArray(selectedContact.conversation) ? selectedContact.conversation : []).map((msg, i) => (
                    <div key={i} style={{ alignSelf: msg.direction === 'outbound' ? 'flex-end' : 'flex-start', maxWidth: '80%' }}>
                      <div style={{ padding: '10px 14px', backgroundColor: msg.direction === 'outbound' ? '#1A56DB' : '#F4F7FF', color: msg.direction === 'outbound' ? '#fff' : '#0C1A2E', borderRadius: msg.direction === 'outbound' ? '12px 12px 2px 12px' : '12px 12px 12px 2px', fontSize: '13px', lineHeight: 1.6, border: msg.direction === 'inbound' ? '1px solid #DDE3F0' : 'none', whiteSpace: 'pre-line' }}>
                        {msg.body}
                      </div>
                      <div style={{ fontSize: '11px', color: '#9AABBE', textAlign: msg.direction === 'outbound' ? 'right' : 'left', marginTop: '4px' }}>{formatDate(msg.timestamp)}</div>
                    </div>
                  ))}
                </div>

                {/* Notes */}
                <div style={{ padding: '10px 20px', borderTop: '1px solid #EEF2FF', borderBottom: '1px solid #EEF2FF' }}>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <input type="text" value={noteText} onChange={e => setNoteText(e.target.value)}
                      onKeyDown={e => e.key === 'Enter' && handleSaveNote()}
                      placeholder="Add a note..."
                      style={{ flex: 1, padding: '7px 12px', borderRadius: '8px', border: '1px solid #DDE3F0', fontSize: '13px', fontFamily: FONT, outline: 'none', color: '#0C1A2E' }} />
                    <button onClick={handleSaveNote} style={{ padding: '7px 14px', borderRadius: '8px', border: 'none', backgroundColor: '#F4F7FF', color: '#5A6B84', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>Save</button>
                  </div>
                  {selectedContact.notes && <div style={{ fontSize: '12px', color: '#5A6B84', marginTop: '6px' }}>📝 {selectedContact.notes}</div>}
                </div>

                {/* Reply box (disabled for anyone who opted out) */}
                <div style={{ padding: '12px 20px' }}>
                  {hasOptedOut(selectedContact) ? (
                    <div style={{ padding: '10px 14px', backgroundColor: '#F4F7FF', border: '1px solid #DDE3F0', borderRadius: '8px', fontSize: '13px', color: '#5A6B84' }}>
                      🚫 This contact opted out or is marked not interested, so replies are turned off.
                    </div>
                  ) : (
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <input type="text" value={replyText} onChange={e => setReplyText(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && !e.shiftKey && handleReply()}
                        placeholder="Type a reply…"
                        style={{ flex: 1, padding: '10px 14px', borderRadius: '8px', border: '1px solid #DDE3F0', fontSize: '14px', fontFamily: FONT, outline: 'none', color: '#0C1A2E' }} />
                      <button onClick={handleReply} disabled={sendingReply || !replyText.trim()}
                        style={{ padding: '10px 16px', borderRadius: '8px', border: 'none', backgroundColor: sendingReply || !replyText.trim() ? '#DDE3F0' : '#F97316', color: sendingReply || !replyText.trim() ? '#9AABBE' : '#fff', fontSize: '13px', fontWeight: 700, cursor: sendingReply || !replyText.trim() ? 'not-allowed' : 'pointer', fontFamily: FONT }}>
                        {sendingReply ? '…' : 'Send'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Outreach;